<script setup lang="ts">
import { ref, toRefs } from 'vue'

const props = defineProps<{
  id?: number
  img?: string
  text?: string
  subtitle?: string
  personal?: boolean
}>()

const { img, text } = toRefs(props)
const hovering = ref(false)
</script>

<template>
  <div
    class="d-flex align-center z-index-3 pb-3 pt-3"
    style="height: 100%; width: 100%; transition: background-color 0.2s"
    v-bind="$attrs"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
  >
    <img
      v-if="img"
      :src="props.img"
      class="mr-4 bg-white object-cover"
      :class="[props.personal ? 'rounded-xl' : 'rounded']"
      :style="{ opacity: hovering ? 0.5 : 1 }"
      height="32px"
      width="32px"
    />

    <span v-if="text" class="mr-1 text-grey-2" style="width: 80%">
      <p class="text-body-1 font-weight-medium text-truncate">
        {{ props.text }}
      </p>
      <p v-if="subtitle" class="text-caption">{{ props.subtitle }}</p>
    </span>

    <slot style="width: 20%"></slot>
  </div>
</template>

<style scoped>
.opacity-50 {
  opacity: 0.5;
  transition: opacity 0.2s;
}
</style>
